import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { CModal, CModalHeader, CModalBody, CModalTitle, CButton } from '@coreui/react';
import { BsArrowRight } from 'react-icons/bs';
import { FaEdit } from "react-icons/fa";
import '../../../assets/css/mainstyle.css';
import Profilimg from '../../../assets/images/man-438081_960_720.png';
import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import api from '../../../service/caller';
import { ToastContainer, toast } from 'react-toastify';
import ScheduleModal from './scheduleEdit';
import Adminprofil from '../../../assets/images/adminprofil.png';



const animatedComponents = makeAnimated();

const AddStaffModal = ({ visible, onClose, handleStaffAdded, initialData, setVisible, modalValue, handleButtonClick }) => {

    const [formData, setFormData] = useState({
        hospital_id: initialData?.hospital_id || "",
        firstname: initialData?.firstname || "",
        lastname: initialData?.lastname || "",
        username: initialData?.username || "",
        email: initialData?.email || "",
        password: "",
        confirmPassword: "",
        role: initialData?.role || "",
        // Ajout d'un tableau pour stocker les permissions sélectionnées
        permissions: initialData?.permissions || [],
        specialties: initialData?.specialties || [],
        contact: {
            phone: initialData?.contact?.phone || "",
            address: initialData?.contact?.address || ""
        },
        departementId: initialData?.departementId || [],
        type: initialData?.type || "",
        civility: initialData?.civility || "",
        firstlogin: true,
    });

    const [Specialities, setSpecialities] = useState([]);
    const [Hospitals, setHospitals] = useState([]);
    const [Departments, setDepartments] = useState([]);
    const [Roles, setRoles] = useState([]);
    // Ajouter un état pour stocker toutes les permissions disponibles
    const [allPermissions, setAllPermissions] = useState([]);
    const [showScheduleModal, setShowScheduleModal] = useState(false);
    const [newlyCreatedStaff, setNewlyCreatedStaff] = useState(null);
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [pendingStaff, setPendingStaff] = useState(null);



    // Ajouter un état pour les permissions filtrées en fonction du rôle sélectionné
    const [filteredPermissions, setFilteredPermissions] = useState([]);
    const [errors, setErrors] = useState({});
    const [filteredSpecialities, setFilteredSpecialities] = useState([]);

    const navigate = useNavigate();

    useEffect(() => {
        const fetchHospitals = async () => {
            try {
                const token = localStorage.getItem('access_token');
                const response = await api.get(`api/hospitals/admin/${token}`);
                setHospitals(response.data);
            } catch (error) {
                toast.error("Error fetching Hospitals");
                console.error("Error fetching Hospitals:", error);
            }
        };

        fetchHospitals();
    }, []);

    useEffect(() => {
        const fetchData = async () => {

            if (!formData.hospital_id || formData.hospital_id.length === 0) return;

            try {
                // Fetch Departments
                const departmentsResponse = await api.post(`/api/departments/byhospitals`, {
                    hospitalIds: formData.hospital_id
                });
                setDepartments(departmentsResponse.data.data);

                // Fetch Roles
                const rolesResponse = await api.get('api/getallroles');
                setRoles(rolesResponse.data);

                // Extraire toutes les permissions uniques de tous les rôles
                const permissionsSet = new Set();
                rolesResponse.data.forEach(role => {
                    role.permissions.forEach(permission => {
                        permissionsSet.add(permission);
                    });
                });

                setAllPermissions(Array.from(permissionsSet));
            } catch (error) {
                toast.error("Error fetching data");
                console.error("Error fetching data:", error);
            }
        };

        fetchData();
    }, [formData.hospital_id]);


    // Mettre à jour les permissions filtrées lorsque le rôle change
    useEffect(() => {
        if (formData.role && Roles.length > 0) {
            const selectedRole = Roles.find(role => role._id === formData.role);
            if (selectedRole) {
                setFilteredPermissions(selectedRole.permissions);
                // Pre-remplir le formData avec les permissions du rôle sélectionné
                setFormData(prevData => ({
                    ...prevData,
                    permissions: selectedRole.permissions
                }));
            }
        }
    }, [formData.role, Roles]);

    if (modalValue && modalValue !== '') {
        formData.role = modalValue;
    }

    const validateForm = () => {
        const newErrors = {};
        if (!formData.firstname) newErrors.firstname = "Firstname is required";
        if (!formData.type) newErrors.type = "Type is required";
        if (!formData.civility) newErrors.civility = "Civility is required";
        if (!formData.lastname) newErrors.lastname = "Lastname is required";
        if (!formData.username) newErrors.username = "Username is required";
        if (!formData.email) newErrors.email = "Email is required";
        if (!formData.password) newErrors.password = "Password is required";
        if (!formData.confirmPassword) newErrors.confirmPassword = "Confirm Password is required";
        if (formData.password && formData.confirmPassword && formData.password !== formData.confirmPassword) {
            newErrors.confirmPassword = "Passwords do not match";
        }
        if (!formData.specialties) newErrors.specialties = "Specialties is required";

        if (!modalValue && !formData.role) {
            newErrors.role = "Role is required";
        }

        if (!formData.departementId) newErrors.departementId = "Department is required";
        if (!formData.hospital_id) newErrors.hospital_id = "Hospital is required";

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        if (name.includes("contact.")) {
            const key = name.split(".")[1];
            setFormData((prevData) => ({
                ...prevData,
                contact: {
                    ...prevData.contact,
                    [key]: value
                }
            }));
        } else {
            setFormData((prevData) => ({
                ...prevData,
                [name]: value
            }));
        }
    };

    const handleHospitalChange = (selectedOptions) => {
        const selectedHospitals = selectedOptions.map(option => option.value);
        setFormData((prevData) => ({
            ...prevData,
            hospital_id: selectedHospitals,
        }));
    };

    // Gestionnaire pour le changement de rôle
    const handleRoleChange = (e) => {
        const roleId = e.target.value;

        // Trouver le rôle sélectionné et ses permissions
        const selectedRole = Roles.find(role => role._id === roleId);
        const rolePermissions = selectedRole ? selectedRole.permissions : [];

        setFormData((prevData) => ({
            ...prevData,
            role: roleId,
            // Pré-remplir les permissions avec celles du rôle sélectionné
            permissions: rolePermissions
        }));

        // Mettre à jour les permissions disponibles en fonction du rôle
        if (roleId) {
            if (selectedRole) {
                setFilteredPermissions(selectedRole.permissions);
            } else {
                setFilteredPermissions([]);
            }
        } else {
            setFilteredPermissions([]);
        }
    };

    // Gestionnaire pour le changement des permissions
    const handlePermissionsChange = (selectedOptions) => {
        setFormData((prevData) => ({
            ...prevData,
            permissions: selectedOptions ? selectedOptions.map((option) => option.value) : [],
        }));
    };

    const handleContinue = async (hospitalId, userId) => {
        try {
            const res = await api.get(`api/users/${userId}`);
            setNewlyCreatedStaff(res.data);
            setShowScheduleModal(true);
        } catch (err) {
            toast.error("Impossible de charger les infos du staff.");
        }
    };


    const handleDepartmentChange = async (selectedOptions) => {
        const selectedDepartmentIds = selectedOptions.map(dep => dep.value);

        if (!formData.hospital_id || formData.hospital_id.length === 0) {
            setSpecialities([{ label: 'No Specialty', value: 'no_specialty' }]);
            return;
        }

        if (selectedDepartmentIds.includes('all')) {
            setFormData(prev => ({
                ...prev,
                departementId: ['all']
            }));

            try {
                const responses = await Promise.all(
                    formData.hospital_id.map(hospitalId =>
                        api.get(`/api/specialities/hospital/${hospitalId}`)
                    )
                );

                const allSpecialities = responses.flatMap(response =>
                    Array.isArray(response.data) ? response.data :
                        Array.isArray(response.data?.data) ? response.data.data :
                            []
                );

                const uniqueSpecialities = Array.from(new Map(
                    allSpecialities.filter(item => item?._id)
                        .map(item => [item._id, item])
                ).values());

                setSpecialities([
                    { label: "No Specialty", value: "no_specialty" },
                    ...uniqueSpecialities.map(spec => ({
                        label: spec.name,
                        value: spec._id
                    }))
                ]);

            } catch (error) {
                console.error("Failed to fetch specialities");
                setSpecialities([{ label: 'No Specialty', value: 'no_specialty' }]);
            }
            return;
        }

        setFormData(prev => ({
            ...prev,
            departementId: selectedDepartmentIds
        }));

        try {
            const res = await api.post('/api/specialities/bydepartments', {
                departmentIds: selectedDepartmentIds
            });

            setSpecialities([
                { label: "No Specialty", value: "no_specialty" },
                ...(res.data?.data?.map(spec => ({
                    label: spec.name,
                    value: spec._id
                })) || [])
            ]);
        } catch (error) {
            console.error("Failed to fetch specialities");
            setSpecialities([{ label: 'No Specialty', value: 'no_specialty' }]);
        }
    };

    // Gestion du changement des spécialités
    const handleSpecialtiesChange = (selectedOptions) => {
        const selectedValues = selectedOptions ? selectedOptions.map((option) => option.value) : [];

        // Si "No Specialty" est sélectionné, on ne garde que cette option
        if (selectedValues.includes('no_specialty')) {
            setFormData(prev => ({
                ...prev,
                specialties: ['no_specialty']
            }));
            return;
        }

        setFormData(prev => ({
            ...prev,
            specialties: selectedValues
        }));
    };
    const [selectedFile, setSelectedFile] = useState(null);
    const [previewImage, setPreviewImage] = useState(Adminprofil);

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            setSelectedFile(file);
            setPreviewImage(URL.createObjectURL(file)); // Affichage de l'aperçu
        }
    };

    // Nettoyer l'URL créée quand le composant est démonté ou qu'une nouvelle image est chargée
    
    useEffect(() => {
        return () => {
            if (previewImage) {
                URL.revokeObjectURL(previewImage);
            }
        };
    }, [previewImage]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (validateForm()) {
            // Créer un objet FormData pour pouvoir envoyer le fichier
            const formData1 = new FormData();
            // Ajouter tous les champs de texte
            formData1.append('hospital_id', JSON.stringify(formData.hospital_id));
            formData1.append('firstname', formData.firstname);
            formData1.append('lastname', formData.lastname);
            formData1.append('username', formData.username);
            formData1.append('email', formData.email);
            formData1.append('password', formData.password);
            formData1.append('role', (modalValue && modalValue !== 'Allusers') ? modalValue : formData.role);
            formData1.append('permissions', JSON.stringify(formData.permissions));
            formData1.append('specialties', JSON.stringify(formData.specialties));
            formData1.append('contact', JSON.stringify(formData.contact));
            formData1.append('departementId', JSON.stringify(formData.departementId));
            formData1.append('civility', formData.civility);
            formData1.append('type', formData.type);
            formData1.append('firstlogin', true);
            // Ajouter le fichier s'il existe
            if (selectedFile) {
                formData1.append('picture', selectedFile);
            }
            try {
                const response = await api.post('api/adduser', formData1, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                });

                if (response.status == 200 || response.status == 201) {
                    toast.success("Staff registered successfully!");
                    setFormData({
                        hospital_id: "",
                        firstname: "",
                        lastname: "",
                        username: "",
                        email: "",
                        password: "",
                        confirmPassword: "",
                        role: "",
                        permissions: [], // Réinitialiser les permissions
                        specialties: [],
                        contact: {
                            phone: "",
                            address: ""
                        },
                        departementId: "",
                        type: "",
                        civility: "",
                    });
                    handleStaffAdded();

                    // Affiche le modal de confirmation custom
                    setPendingStaff({
                        hospitalId: response?.data?.user?.hospital_id,
                        userId: response?.data?.user?._id
                    });
                    setShowConfirmModal(true);

                    onClose();
                } else {
                    toast.error(response.data.message || "Failed to register staff. Please try again.");
                }
            } catch (error) {
                toast.error(`Registration failed: ${error?.response?.data?.message || 'An unexpected error occurred. Please try again.'}`);
                console.error('Error:', error?.response || 'No error message available.');
            }
        }
    };

    return (
        <>
            <CModal
                className='newregistermodal'
                alignment="center"
                scrollable
                size='lg'
                visible={visible}
                onClose={onClose}
            >
                <CModalHeader>
                    <CModalTitle className='Titleformsmodal'>Register new staff</CModalTitle>
                </CModalHeader>
                <CModalBody className='p-5'>
                    <form onSubmit={handleSubmit} className='staffaddform'>
                        {/* Profile Picture */}
                        <ToastContainer />
                        <div className="form-group">
                            <div className="profile-photo d-flex">
                                <div className="photo-container">
                                    <img src={previewImage} alt="Profile" className="profile-image" />
                                </div>
                                <div className='photoedit'>
                                    <label htmlFor="file-input2">
                                        <FaEdit />
                                    </label>
                                    <input type="file" id="file-input2" style={{opacity: 0, position: "absolute", width: 0, height: 0}} accept="image/*" onChange={handleFileChange} />
                                    <p className='ms-2'>Upload profile photo (jpg, png, jpeg)</p>
                                </div>
                            </div>
                        </div>
                        {/* Hospital Select */}
                        <div className="form-group firstformgroup">
                            <label htmlFor="hospital_id">Hospital</label>
                            <Select
                                isMulti
                                name="hospital_id"
                                id="hospital_id"
                                options={Hospitals.map(hospital => ({
                                    label: hospital.hospital_name,
                                    value: hospital._id
                                }))}
                                value={Hospitals.filter(hospital => formData.hospital_id.includes(hospital._id))
                                    .map(hospital => ({
                                        label: hospital.hospital_name,
                                        value: hospital._id
                                    }))}
                                onChange={handleHospitalChange}
                                isSearchable
                                placeholder="Select Hospitals"
                                styles={{
                                    control: (provided) => ({
                                        ...provided,
                                        borderColor: '#0056B3',
                                        border: '2px solid #0056B3',
                                        borderRadius: '10px',
                                        minHeight: '50px',
                                    }),
                                }}
                            />
                            {errors.hospital_id && <div className="text-danger">{errors.hospital_id}</div>}
                        </div>


                        <>
                            {/* Department */}
                            <div className="form-group firstformgroup">
                                <label htmlFor="departementId">Department</label>
                                <Select
                                    isMulti
                                    name="departementId"
                                    id="departementId"
                                    options={[
                                        { label: "All Departments", value: "all" },
                                        ...Departments.map(dep => ({
                                            label: dep.name,
                                            value: dep._id
                                        }))
                                    ]}
                                    value={
                                        formData.departementId.includes('all')
                                            ? [{ label: "All Departments", value: "all" }]
                                            : Departments.filter(dep =>
                                                formData.departementId.includes(dep._id)
                                            ).map(dep => ({
                                                label: dep.name,
                                                value: dep._id
                                            }))
                                    }
                                    onChange={handleDepartmentChange}
                                    isSearchable
                                    placeholder="Select Departments"
                                    styles={{
                                        control: (provided) => ({
                                            ...provided,
                                            borderColor: '#0056B3',
                                            border: '2px solid #0056B3',
                                            borderRadius: '10px',
                                            minHeight: '50px',
                                        }),
                                    }}
                                />
                                {errors.departementId && <div className="text-danger">{errors.departementId}</div>}
                            </div>


                            {/* Specialties */}
                            <div className="form-group firstformgroup">
                                <label htmlFor="specialties">Specialties</label>
                                <Select
                                    closeMenuOnSelect={false}
                                    components={animatedComponents}
                                    isMulti
                                    name="specialties"
                                    id="specialties"
                                    options={Specialities}
                                    onChange={handleSpecialtiesChange}
                                    value={
                                        formData.specialties.includes('no_specialty')
                                            ? [{ label: "No Specialty", value: "no_specialty" }]
                                            : formData.specialties
                                                .filter(specialty => specialty !== 'no_specialty')
                                                .map(specialtyId => {
                                                    const found = Specialities.find(s => s.value === specialtyId);
                                                    return found ? { label: found.label, value: found.value } : null;
                                                })
                                                .filter(Boolean)
                                    }
                                    isSearchable
                                    placeholder="Select Specialties"
                                    styles={{
                                        control: (provided) => ({
                                            ...provided,
                                            borderColor: '#0056B3',
                                            border: '2px solid #0056B3',
                                            borderRadius: '10px',
                                            minHeight: '50px',
                                        }),
                                    }}
                                />
                                {errors.specialties && <div className="text-danger">{errors.specialties}</div>}
                            </div>
                        </>

                        <div className='row'>
                            {/* Name */}
                            <div className="form-group col-md-6">
                                <label htmlFor="firstname">Firstname</label>
                                <input
                                    type="text"
                                    name="firstname"
                                    id="firstname"
                                    placeholder="John Doe"
                                    value={formData.firstname}
                                    onChange={handleInputChange}
                                />
                                {errors.firstname && <div className="text-danger">{errors.firstname}</div>}
                            </div>
                            {/* Username */}
                            <div className="form-group col-md-6">
                                <label htmlFor="lastname">Lastname</label>
                                <input
                                    type="text"
                                    name="lastname"
                                    id="lastname"
                                    placeholder="johndoe"
                                    value={formData.lastname}
                                    onChange={handleInputChange}
                                />
                                {errors.lastname && <div className="text-danger">{errors.lastname}</div>}
                            </div>
                        </div>
                        {/* Username */}
                        <div className="form-group">
                            <label htmlFor="username">Username</label>
                            <input
                                type="text"
                                name="username"
                                id="username"
                                placeholder="johndoe"
                                value={formData.username}
                                onChange={handleInputChange}
                            />
                            {errors.username && <div className="text-danger">{errors.username}</div>}
                        </div>


                        <div className='row'>
                            {/* Type */}
                            <div className="form-group col-md-6">
                                <label htmlFor="type">Type</label>
                                <select
                                    name="type"
                                    id="type"
                                    onChange={handleInputChange}
                                    value={formData.type}
                                >
                                    <option value="">Select Type</option>
                                    {['Permanent', 'Consultant'].map(type => (
                                        <option key={type} value={type}>
                                            {type}
                                        </option>
                                    ))}
                                </select>
                                {errors.type && <div className="text-danger">{errors.type}</div>}
                            </div>

                            {/* Civility */}
                            <div className="form-group col-md-6">
                                <label htmlFor="civility">Civility</label>
                                <select
                                    name="civility"
                                    id="civility"
                                    onChange={handleInputChange}
                                    value={formData.civility}
                                >
                                    <option value="">Select Civility</option>
                                    {['M.', 'Mme.'].map(civility => (
                                        <option key={civility} value={civility}>
                                            {civility}
                                        </option>
                                    ))}
                                </select>
                                {errors.civility && <div className="text-danger">{errors.civility}</div>}
                            </div>
                        </div>

                        {/* Role */}
                        {(!modalValue || modalValue == 'Allusers') && (
                            <div className="form-group col-md-12">
                                <label htmlFor="role">Fonction</label>
                                <select
                                    name="role"
                                    id="role"
                                    onChange={handleRoleChange}
                                    value={formData.role}
                                >
                                    <option value="">Select Role</option>
                                    {Roles.map((role) => (
                                        <option key={role._id} value={role._id}>
                                            {role.name.replace(/^medtinz_client_/, '').replace(/_/g, ' ')}
                                        </option>
                                    ))}
                                </select>
                                {errors.role && <div className="text-danger">{errors.role}</div>}
                            </div>
                        )}

                        {/* Permissions - Affiché seulement si un rôle est sélectionné */}
                        {formData.role && (
                            <div
                                className="form-group"
                                style={{
                                    marginBottom: '10px',
                                    marginTop: '20px',
                                    backgroundColor: '#f9f9f9',
                                    position: 'relative',
                                    paddingTop: '10px',
                                }}
                            >
                                <label
                                    style={{
                                        fontSize: '16px',
                                        color: '#333',
                                        position: 'absolute',
                                        top: '-10px',
                                        left: '0',
                                    }}
                                >
                                    Permissions
                                </label>
                                <Select
                                    closeMenuOnSelect={false}
                                    components={animatedComponents}
                                    isMulti
                                    options={allPermissions.map((permission) => ({
                                        label: permission.replace(/^medtinz_client_/, '').replace(/_/g, ' '),
                                        value: permission,
                                    }))}
                                    onChange={handlePermissionsChange}
                                    value={formData.permissions.map((permission) => ({
                                        label: permission.replace(/^medtinz_client_/, '').replace(/_/g, ' '),
                                        value: permission,
                                    }))}
                                    styles={{
                                        control: (provided) => ({
                                            ...provided,
                                            borderColor: '#0056B3',
                                            border: '2px solid #0056B3',
                                            borderRadius: '10px',
                                            minHeight: '50px',
                                        }),
                                    }}
                                />
                                {/* <div className="text-info mt-2 small">
                                <p>Default permissions for this role: 
                                    <br />
                                    {filteredPermissions.join(', ')}
                                </p>
                            </div> */}
                            </div>
                        )}

                        {/* Email */}
                        <div className="form-row row">
                            <div className="form-group col-md-12">
                                <label htmlFor="email">Email</label>
                                <input
                                    type="email"
                                    name="email"
                                    id="email"
                                    placeholder="johndoe@example.com"
                                    value={formData.email}
                                    onChange={handleInputChange}
                                />
                                {errors.email && <div className="text-danger">{errors.email}</div>}
                            </div>
                            {/* Password */}
                            <div className="form-group col-md-6">
                                <label htmlFor="password">Password</label>
                                <input
                                    type="password"
                                    name="password"
                                    id="password"
                                    placeholder="Password123!"
                                    value={formData.password}
                                    onChange={handleInputChange}
                                />
                                {errors.password && <div className="text-danger">{errors.password}</div>}
                            </div>
                            <div className="form-group col-md-6">
                                <label htmlFor="confirmPassword">Confirm Password</label>
                                <input
                                    type="password"
                                    name="confirmPassword"
                                    id="confirmPassword"
                                    placeholder="Password123!"
                                    value={formData.confirmPassword}
                                    onChange={handleInputChange}
                                />
                                {errors.confirmPassword && <div className="text-danger">{errors.confirmPassword}</div>}
                            </div>
                        </div>
                        {/* Phone and Address */}
                        <div className="form-row row">
                            <div className="form-group col-md-6">
                                <label htmlFor="contact.phone">Phone</label>
                                <input
                                    type="tel"
                                    name="contact.phone"
                                    id="contact.phone"
                                    placeholder="0123456789"
                                    value={formData.contact.phone}
                                    onChange={handleInputChange}
                                />
                                {errors.phone && <div className="text-danger">{errors.phone}</div>}
                            </div>
                            <div className="form-group col-md-6">
                                <label htmlFor="contact.address">Address</label>
                                <input
                                    type="text"
                                    name="contact.address"
                                    id="contact.address"
                                    placeholder="123 Main St"
                                    value={formData.contact.address}
                                    onChange={handleInputChange}
                                />
                            </div>
                        </div>
                        {/* Submit Button */}
                        <div className="form-group d-flex justify-content-center">
                            <CButton color="primary" type="submit">
                                Continue &nbsp; <BsArrowRight />
                            </CButton>
                        </div>

                    </form>

                </CModalBody>

            </CModal>

            <CModal visible={showConfirmModal} onClose={() => setShowConfirmModal(false)}>
                <CModalHeader closeButton>
                    <CModalTitle>Confirmation</CModalTitle>
                </CModalHeader>
                <CModalBody>
                    <p>Souhaitez-vous configurer son Scheduler maintenant ?</p>
                    <div className="d-flex justify-content-end gap-2 mt-4">
                        <CButton
                            color="primary"
                            onClick={() => {
                                handleContinue(pendingStaff.hospitalId, pendingStaff.userId);
                                setShowConfirmModal(false);
                            }}
                        >
                            Oui
                        </CButton>
                        <CButton color="secondary" onClick={() => setShowConfirmModal(false)}>
                            Non
                        </CButton>
                    </div>
                </CModalBody>
            </CModal>


            <ScheduleModal
                visible={showScheduleModal}
                onClose={() => setShowScheduleModal(false)}
                onScheduleUpdated={() => {
                    toast.success("Planning configuré avec succès !");
                    setShowScheduleModal(false);
                }}
                staff={newlyCreatedStaff}
            />
        </>
    );
};

export default AddStaffModal;